<template>
  <div v-if="text" class="cat-help mbt">
    <cat-btn
      :aria-expanded="expanded ? 'true' : 'false'"
      :aria-controls="id + '_help'"
      :icon="expanded ? 'angle-down' : 'angle-right'"
      :icon-label="resolveTxt('skin.help.inline.icon.label', '')"
      class="inline-help-trigger mln mbx pn small simple"
      :label="heading"
      :data-button="heading"
      :data-label="heading"
      data-label-type="help-title"
      :aria-describedby="ariaDescribedby"
      @ui-click="toggle"
    />
    <div class="cat-help-content">
      <transition-expand>
        <conditional-group
          v-show="expanded"
          :id="id + '_help'"
          class="field-help-text mrn mtn"
          data-label-type="help-text"
          role="alert"
          aria-live="polite"
          v-html="text"
        >
        </conditional-group>
      </transition-expand>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, inject } from "vue";
import { defaultResolveTxt } from "@/components/field-element";
import ConditionalGroup from "../fieldsets/conditional-group";
import CatBtn from "@/components/catBtn/catBtn";
import TransitionExpand from "./catTransitionExpand";
import { defaultStopProcessUpdate } from "@/components/utilities/processUpdateMixin";

export default defineComponent({
  setup() {
    // Inject the global value
    const resolveTxt = inject("resolveTxt", defaultResolveTxt);
    const stopProcessUpdate = () => defaultStopProcessUpdate;

    return {
      resolveTxt,
      stopProcessUpdate
    };
  },
  name: "CatHelp",
  components: { TransitionExpand, ConditionalGroup, CatBtn },
  props: {
    id: {
      type: String,
      description: "Inline help id"
    },
    heading: {
      type: String,
      description: "Defines help heading"
    },
    text: {
      type: String,
      description: "Defines help text"
    },
    ariaDescribedby: {
      type: String,
      description: "aria attribute to help describe the button"
    }
  },
  data: function () {
    return {
      expanded: false
    };
  },
  methods: {
    toggle: function () {
      this.expanded = !this.expanded;
      this.stopProcessUpdate("help.vue name: cat-help method: toggle");
    }
  }
});
</script>
